import { create } from "zustand"

type AddToWorkflowDialogState = {
  isOpen: boolean
}

type AddToWorkflowDialogActions = {
  onOpen: () => void
  onClose: () => void
}

const useAddToWorkflowDialogV1 = create<
  AddToWorkflowDialogState & AddToWorkflowDialogActions
>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false }),
}))

export default useAddToWorkflowDialogV1
